import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ui-menu-device",
  "use": "ui-menu-device-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"ui-menu-device\"><g id=\"ui-menu-device_asus_proart_sw_ico_display\"><rect width=\"48\" height=\"48\" fill=\"none\" /><path d=\"M40,9H8a1,1,0,0,0-1,1V27.69a5,5,0,0,0,5,5H23V37H15v2H33V37H25V32.69H36a5,5,0,0,0,5-5V10A1,1,0,0,0,40,9ZM39,27.69a3,3,0,0,1-3,3H12a3,3,0,0,1-3-3V11H39Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol